import React from 'react';
import { render } from 'react-dom';

import ItinerarySidebar from '../react/ItinerarySidebar';

export default class ItineraryRender {
  constructor(context) {
    this.context = context;
    this.init();
  }

  init() {
    const { model, abandonBasketApi, tourKey } = this.context.dataset;
    if (!model || !abandonBasketApi || !tourKey) throw Error('Missing a required dataset');
    const jsonModel = JSON.parse(model);

    render(
      <ItinerarySidebar
        {...jsonModel}
        abandonBasketApi={abandonBasketApi}
        tourKey={tourKey}
        activeOnLoad
      />,
      this.context
    );
  }
}
